const login = (username, password) => {
    const requestOptions = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Client-Service": "USER-client",
        "Auth-Key" : "dmsfrontendapi",
        "x-api-version" : "1.0.0"
      },
      body: JSON.stringify({ 
        "email": username,
        "password": password
      })
    };

    return fetch(`${process.env.REACT_APP_APILIVEBASEURL}/login`, requestOptions)
      .then(response => response.json())
      .then(result => {
       
          if (result.message === 'success' && result.token) {
            localStorage.setItem("user", JSON.stringify(result));
            //return result;
          }//else{
            //return result;
          //}
          return result;
      },(error) => {
          if (error) {
            // console.log(error);
            alert(error);
          }
      });
  };
    
const logout = () => {
  localStorage.removeItem("user");
  // localStorage.removeItem("loggedSubareaId")
  // localStorage.removeItem("loggedCscId")
  // localStorage.removeItem("pricingDate");
  // localStorage.removeItem("loggedCscName");
};
const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};
const AuthService = {
  login,
  logout,
  getCurrentUser,
};
export default AuthService;